<script setup lang="ts">
    import saveAs from 'file-saver';
    import useShow from '@/shared/composables/useShow.js';
    import { http } from '@/shared/httpWrapper.js';
    import { useSqlEditorStore } from '@/stores/sqlEditorStore.ts';
    import { sqlQueryToExcel } from '@/shared/helpers/api';

    const store = useSqlEditorStore();
    const { showError } = useShow();

    function getFileName() {
        if (store.queryIsLoaded) {
            return `${store.loadedQueryOriginalName}.xlsx`;
        } else {
            const selectedLibrary = store.libraryGetSelected();
            return selectedLibrary
                ? `${selectedLibrary}_result.xlsx`
                : 'result.xlsx';
        }
    }

    async function runExport() {
        store.errorClear();
        try {
            const response = await sqlQueryToExcel(http, store.loadedQueryGetRunRequest());

            if (response.data) {
                const blob = new Blob([response.data], { type: response.headers['Content-Type']?.toString() });
                saveAs(blob, getFileName());
            }
        } catch (ex) {
            showError(ex, store.errorSet);
        }
    }
</script>

<template>
    <button
        class="button"
        @click="runExport">
        <b-icon
            icon="download"
            size="is-small" />
        <span>Excel export</span>
    </button>
</template>
